import { createAction } from "typesafe-actions";

export const toggleCallModalOpen = createAction("TOGGLE_CALL_MODAL_OPEN");
export const togglePushModalOpen = createAction("TOGGLE_PUSH_MODAL_OPEN");



// WEBPACK FOOTER //
// ./src/actions/callActions.ts